import React, { Component } from "react";
import { withRouter } from "./withRouter";
import ReactMap, { Source, Layer } from "react-map-gl";
import maplibregl from "maplibre-gl";
import { Box, Stack, Typography,ToggleButtonGroup,ToggleButton,Autocomplete,TextField,Paper,
  IconButton,
  Divider,
  Tooltip
   } from "@mui/material";
  import {
  ZoomIn as ZoomInIcon,
  Close as CloseIcon,
  ArrowForward as ArrowForwardIcon,
  East as EastIcon,
} from "@mui/icons-material";
import NZ2026HomeTooltip from "./NZ2026HomeTooltip"
import NZ2026SeatCompTooltip from "./NZ2026SeatCompTooltip"
import TooltipInternalMainMap from "./TooltipInternalMainMap"
import TooltipInternalHeatMap from "./TooltipInternalHeatMap"
import { registerArrowImage } from "./buildCompareArrows";
import SegmentsTooltip from "./SegmentsTooltip"
import { CONSTITUENCIES as possibleAreas } from "./constants/areas";

const MAP_STYLE = "https://basemaps.cartocdn.com/gl/positron-gl-style/style.json";
const glassSx = {
  background: "rgba(255, 255, 255, 0.75)",
  backdropFilter: "blur(12px)", 
  WebkitBackdropFilter: "blur(12px)",
  border: "1px solid rgba(255, 255, 255, 0.5)", 
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",  
  borderRadius: 3,                       
};

class MapComponent extends Component {

// In the class body
onStyleLoad = () => {
  const map = this.props.mapRef?.current?.getMap?.();
  if (map) {
    registerArrowImage(map);
    // Re-register if style reloads and image goes missing
    map.on("styleimagemissing", (e) => {
      if (e?.id === "compare-arrow") registerArrowImage(map);
    });
  }
  // If the parent tracks styleLoaded via props, call upward:
  this.props.onStyleLoad?.();
};
 

  render() {
    const { 
  geoLevel, styledGeo, geoData, hoverInfo,
  compareWaves = false,
  onCompareWavesChange,
  waveOptions = [],
  waveSelect,
  handlewaveSelectChange,
  showArrows = false,
  onShowArrowsToggle,
  comparePartyKey,
  onComparePartyKeyChange,
  comparePartyOptions = [],

} = this.props;
    const { styleLoaded, selectedFeature } = this.props;


    return (
      <div style={{ height: "100%", width: "100%" }}>
        {selectedFeature?.name && (
          <div
            style={{
              position: "absolute",
              top: 12,
              left: 12,
              background: "rgba(255,255,255,0.95)",
              padding: "6px 10px",
              borderRadius: 6,
              fontFamily: "Inter, system-ui, sans-serif",
              fontSize: 13,
              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <strong>Selected:</strong> {selectedFeature.name}
            <button
              onClick={() => this.setState({ selectedFeature: null })}
              style={{
                border: "none",
                background: "transparent",
                cursor: "pointer",
                fontSize: 16,
                lineHeight: 1,
                color: "#666",
                marginLeft: 6,
              }}
              aria-label="Clear selection"
              title="Clear selection"
            >
              
            </button>
          </div>
        )}

        <ReactMap
          ref={this.props.mapRef}
            initialViewState={{
                    bounds: [
                    [166.0, -47.5], // SW
                    [179.0, -33.0], // NE
                    ],
                    fitBoundsOptions: { padding: 40 }, // optional, gives margin
                }}
          style={{ width: "100%", height: "100%" }}
          mapLib={maplibregl}
          mapStyle={MAP_STYLE}
          interactiveLayerIds={["geo-fill"]}
            renderWorldCopies={true}
          onClick={this.props.onMapClick}
          onMouseMove={this.props.onMouseMove}
          onLoad={this.onStyleLoad}
          viewState={this.props.viewState ? this.props.viewState : null}
        >
          {styleLoaded && (styledGeo || geoData)?.features && (
            <Source id="geo" type="geojson" data={styledGeo || geoData}>
              <Layer
                id="geo-fill"
                type="fill"
                paint={{
                  "fill-color": ["coalesce", ["get", "fillColor"], "#ffffff"],
                  "fill-opacity": ["case", ["has", "fillColor"], 0.75, 0],
                }}
              />
              <Layer
                id="geo-outline"
                type="line"
                paint={{
                  "line-color": "#111",
                  "line-width": 0.25,
                  "line-opacity": ["case", ["has", "fillColor"], 0.025, 0],
                }}
              />
              {selectedFeature?.level && (
                <Layer
                  id="geo-hover"
                  type="line"
                  paint={{
                    "line-color": "#ffffff",
                    "line-width": 2,
                  }}
                  filter={[
                    "==",
                    ["get",  "area_id"],
                    hoverInfo?.props?.["area_id"] || "",
                  ]}
                />
              )}
              <Layer
                id="geo-selected-halo"
                type="line"
                paint={{
                  "line-color": "#ffffff",
                  "line-width": 4,
                }}
                filter={
                  selectedFeature?.level === geoLevel && selectedFeature?.value
                    ? ["==", ["get", selectedFeature.key], selectedFeature.value]
                    : ["==", ["get", "__none__"], "__none__"]
                }
              />
              <Layer
                id="geo-selected"
                type="line"
                paint={{
                  "line-color": "#1976d2",
                  "line-width": 2,
                }}
                filter={
                  selectedFeature?.level === geoLevel && selectedFeature?.value
                    ? ["==", ["get", selectedFeature.key], selectedFeature.value]
                    : ["==", ["get", "__none__"], "__none__"]
                }
              />
            </Source>
          )}

          {this.props.styleLoaded &&
  this.props.compareWaves &&
  this.props.compareArrows?.features?.length > 0 &&
  this.props.showArrows !== false && (
    <Source id="compare-arrows" type="geojson" data={this.props.compareArrows}>
      <Layer
        id="compare-arrows-layer"
        type="symbol"
        layout={{
          "icon-image": "compare-arrow",
          "icon-rotate": ["get", "angle"],
          "icon-size": ["get", "size"],
          "icon-allow-overlap": true,
          "icon-ignore-placement": true,
          "icon-rotation-alignment": "map",
          "icon-anchor": "center",
        }}
        paint={{
  "icon-color": ["get", "color"],
  "icon-opacity": ["get", "opacity"],
}}
      />
    </Source>
  )}
          {hoverInfo && (
            this.props.tooltip === "home" ? (
                <NZ2026HomeTooltip
                hoverInfo={hoverInfo}
                geoData={geoData}
                styledGeo={styledGeo}
                geoLevel={geoLevel}
                waveSelect={this.props.waveSelect}                
                tooltip_pastcomp={this.props.tooltip_pastcomp}
                />
            ) : this.props.tooltip === "seatcomp" ? (

                <NZ2026SeatCompTooltip
                hoverInfo={hoverInfo}
                geoData={geoData}
                styledGeo={styledGeo}
                chosenView = {this.props.chosenView}
                chosenParty = {this.props.chosenParty}
                geoLevel={geoLevel}
                waveSelect={this.props.waveSelect}              
                tooltip_pastcomp={this.props.tooltip_pastcomp}
                />
              
              
            ) : this.props.tooltip === "segments" ? (

             <SegmentsTooltip
                hoverInfo={hoverInfo}
                geoData={geoData}
                styledGeo={styledGeo}
                geoLevel={geoLevel}
                waveSelect={this.props.waveSelect}                
                tooltip_pastcomp={this.props.tooltip_pastcomp}
                />
              
              
            ) : this.props.tooltip ==="InternalMain" ?(
                <TooltipInternalMainMap
                hoverInfo={hoverInfo}
                geoData={geoData}
                styledGeo={styledGeo}
                chosenView = {this.props.chosenView}
                chosenParty = {this.props.chosenParty}
                geoLevel={geoLevel}
                tooltip_pastcomp={this.props.tooltip_pastcomp}
                />
              
            ) : this.props.tooltip === "InternalHeat" ? (

                              <TooltipInternalHeatMap
                hoverInfo={hoverInfo}
                geoData={geoData}
                styledGeo={styledGeo}
                chosenView = {this.props.chosenView}
                chosenParty = {this.props.chosenParty}
                geoLevel={geoLevel}
                tooltip_pastcomp={this.props.tooltip_pastcomp}
                />
            ): (null)
            )}

   {!this.props.smallMap &&(
           <Box
        sx={{
          position: "absolute",
          top: 16,
          left: 16,
          zIndex: 2,
          backgroundColor: "rgba(255,255,255,0.95)",
          borderRadius: 2,
          px: 2,
          paddingTop: 0.5,
          paddingBottom: 1.5,
          pointerEvents: "auto",
          boxShadow: 2
        }}
      >

     

        <Stack direction="row" sx={{
           display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        textAlign: "center",
        //flex: 1, 
        py:0,px:0,
        mb: 0.5}}>
        <Typography
          variant="caption"
          sx={{ display: "block",  color: "text.secondary" }}
        >
          Map Level
        </Typography>
        
              </Stack>

        <ToggleButtonGroup
          value={geoLevel}
          exclusive
          onChange={(e, newLevel) => {
            if (newLevel) this.props.onGeoLevelChange(newLevel);
          }}
          size="small"
        >
          <ToggleButton value="constituency">Electorate</ToggleButton>
          <ToggleButton value="SA3">SA3</ToggleButton>
          <ToggleButton value="SA2">SA2</ToggleButton>

        </ToggleButtonGroup>


      </Box>
   )}
   {!this.props.smallMap &&(

      <Box
        sx={{
          position: "absolute",
          top: 16,
          right: 16,
          zIndex: 2,
          backgroundColor: "rgba(255,255,255,0.95)",
          borderRadius: 2,
          px: 2,
          paddingTop: 0.5,
          paddingBottom: 1.5,
          pointerEvents: "auto",
          boxShadow: 2
        }}
      >

        <Stack direction="row" sx={{
           display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        textAlign: "center",
        //flex: 1, 
        py:0,px:0,
        mb: 0.5}}>
        <Typography
          variant="caption"
          sx={{ display: "block",  color: "text.secondary" }}
        >
          Choose and electorate to zoom in
        </Typography>
        
              </Stack>

         <Autocomplete
            disablePortal
              options={possibleAreas} // the array you passed up
              getOptionLabel={(option) => option.area_name}
            sx={{ width: "100%", mt:1.5, height:1 }}
            value={selectedFeature}
            renderInput={(params) => <TextField {...params} label="Find an area:"
                                                            size="small"             // <-- makes the input smaller
                                                            sx={{
                                                              "& .MuiInputBase-root": { height: 40 },  // adjust overall input height
                                                              "& .MuiOutlinedInput-input": { padding: "4px 8px" } // adjust inner text padding
                                                            }} />}
            onChange={(event, newValue) => {

             if (newValue === null) {
                this.props.resetView({LevelToResetTo:"constituency"})

               }else{
                  this.props.handleselectedFeatureChange(
                    {area_id:newValue?.area_id,area_name:newValue?.area_name}
                  );
                }

            }
          }
          />


      </Box>
        )}

{ this.props.showWaveBox && (
<Paper
    elevation={0}
    sx={{
      ...glassSx,
      position: "absolute",
      bottom: 24,
      right: 20,
      zIndex: 1000,
      overflow: "hidden",
      minWidth: 180,
    }}
  >
    {/* ── Normal mode: wave selector ── */}
    <Box
      sx={{
        overflow: "hidden",
        maxHeight: compareWaves ? 0 : 120,
        opacity: compareWaves ? 0 : 1,
        transition: "max-height 0.3s ease, opacity 0.2s ease",
        pointerEvents: compareWaves ? "none" : "auto",
      }}
    >
      <Box sx={{ px: 1.5, pt: 1.25, pb: 0.5 }}>
        <Typography variant="caption" sx={{
          color: "text.disabled",
          fontWeight: 700,
          fontSize: "0.65rem",
          textTransform: "uppercase",
          letterSpacing: "0.08em",
        }}>
          Wave
        </Typography>
      </Box>
      <Box sx={{ px: 1, pb: 1 }}>
        <ToggleButtonGroup
          value={waveSelect}
          exclusive
          onChange={(e, newWave) => {
            if (newWave !== null) handlewaveSelectChange(newWave);
          }}
          size="small"
          sx={{
            backgroundColor: "rgba(0,0,0,0.04)",
            borderRadius: 2,
            p: 0.4,
            "& .MuiToggleButton-root": {
              border: "none",
              borderRadius: 1.5,
              mx: 0.25,
              py: 0.4,
              px: 1.25,
              textTransform: "none",
              fontWeight: 600,
              fontSize: "0.8rem",
              color: "text.secondary",
              minWidth: 36,
              "&.Mui-selected": {
                backgroundColor: "#fff",
                color: "primary.main",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                "&:hover": { backgroundColor: "#fff" },
              },
              "&:hover": { backgroundColor: "rgba(0,0,0,0.05)" },
            },
          }}
        >
          {waveOptions.map((wave) => (
            <ToggleButton key={wave} value={wave}>{wave}</ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Box>
    </Box>

{this.props.allowCompare && (
  <>
    {/* ── Compare mode: wave pair badge ── */}
    <Box
      sx={{
        overflow: "hidden",
        maxHeight: compareWaves ? 80 : 0,
        opacity: compareWaves ? 1 : 0,
        transition: "max-height 0.3s ease, opacity 0.25s ease",
        pointerEvents: compareWaves ? "auto" : "none",
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 1.5, pt: 1.25, pb: 1 }}>
        <Stack direction="row" alignItems="center" spacing={0.75}>
          {/* Wave pair indicator */}
          <Box sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            bgcolor: "rgba(25,118,210,0.07)",
            border: "1px solid rgba(25,118,210,0.18)",
            borderRadius: 2,
            px: 1,
            py: 0.5,
          }}>
            <Typography sx={{ fontSize: "0.78rem", fontWeight: 700, color: "text.secondary", lineHeight: 1 }}>
              {waveOptions[1]}
            </Typography>
            <EastIcon sx={{ fontSize: 11, color: "primary.main", mx: 0.25 }} />
            <Typography sx={{ fontSize: "0.78rem", fontWeight: 700, color: "primary.main", lineHeight: 1 }}>
              {waveOptions[0]}
            </Typography>
          </Box>
          {/* Arrows toggle */}
          <Tooltip title={showArrows !== false ? "Hide arrows" : "Show arrows"} placement="top">
            <IconButton
              size="small"
              onClick={() => onShowArrowsToggle?.()}
              sx={{
                width: 28,
                height: 28,
                borderRadius: 1.5,
                color: showArrows !== false ? "primary.main" : "text.disabled",
                bgcolor: showArrows !== false ? "rgba(25,118,210,0.08)" : "transparent",
                "&:hover": { bgcolor: "rgba(25,118,210,0.14)" },
              }}
            >
              <ArrowForwardIcon sx={{ fontSize: 14, transform: "rotate(-45deg)" }} />
            </IconButton>
          </Tooltip>
        </Stack>
        {/* Exit compare */}
        <Tooltip title="Exit compare" placement="top">
          <IconButton
            size="small"
            onClick={() => onCompareWavesChange?.(false)}
            sx={{
              width: 24,
              height: 24,
              color: "text.disabled",
              "&:hover": { color: "text.primary", bgcolor: "rgba(0,0,0,0.05)" },
            }}
          >
            <CloseIcon sx={{ fontSize: 13 }} />
          </IconButton>
        </Tooltip>
      </Stack>
    </Box>

    {/* ── Divider + Compare button (always visible) ── */}
       <Divider sx={{ opacity: 0.4 }} />
    <Box
      sx={{
        px: 1,
        py: 0.75,
        cursor: !compareWaves && waveOptions.length >= 2 ? "pointer" : "default",
        "&:hover": !compareWaves && waveOptions.length >= 2 ? { bgcolor: "rgba(0,0,0,0.02)" } : {},
        transition: "background 0.15s",
        opacity: waveOptions.length >= 2 ? 1 : 0.35,
        pointerEvents: waveOptions.length >= 2 ? "auto" : "none",
      }}
      onClick={() => !compareWaves && waveOptions.length >= 2 && onCompareWavesChange?.(true)}
    >
      <Typography sx={{
        fontSize: "0.72rem",
        fontWeight: 600,
        color: compareWaves ? "primary.main" : "text.secondary",
        textAlign: "center",
        letterSpacing: "0.01em",
        userSelect: "none",
      }}>
        {compareWaves ? "Comparing waves" : "Compare latest 2 waves"}
      </Typography>
    </Box>

    {/* ── Party selector (only visible in compare mode) ── */}
      <Box
      sx={{
        overflow: "hidden",
        maxHeight: compareWaves ? 80 : 0,
        opacity: compareWaves ? 1 : 0,
        transition: "max-height 0.3s ease, opacity 0.25s ease, padding 0.3s ease",
        pointerEvents: compareWaves ? "auto" : "none",
        px: compareWaves ? 1 : 0,
        pb: compareWaves ? 1 : 0,
        pt: compareWaves ? 0.5 : 0,
        // Prevent collapsed content from stretching Paper width
        ...(compareWaves ? {} : { position: "absolute", visibility: "hidden" }),
      }}
    >
      <Typography sx={{
        fontSize: "0.65rem",
        fontWeight: 700,
        color: "text.disabled",
        textTransform: "uppercase",
        letterSpacing: "0.08em",
        textAlign: "center",
        mb: 0.5,
      }}>
        Show movement of
      </Typography>
      <ToggleButtonGroup
        value={this.props.comparePartyKey}
        exclusive
        onChange={(e, val) => {
          if (val !== null) this.props.onComparePartyKeyChange?.(val);
        }}
        size="small"
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          backgroundColor: "rgba(0,0,0,0.04)",
          borderRadius: 2,
          p: 0.3,
          gap: 0.25,
          "& .MuiToggleButton-root": {
            border: "none",
            borderRadius: 1.5,
            py: 0.3,
            px: 0.8,
            textTransform: "none",
            fontWeight: 600,
            fontSize: "0.7rem",
            color: "text.secondary",
            minWidth: 0,
            lineHeight: 1.3,
            "&.Mui-selected": {
              backgroundColor: "#fff",
              color: "primary.main",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              "&:hover": { backgroundColor: "#fff" },
            },
            "&:hover": { backgroundColor: "rgba(0,0,0,0.05)" },
          },
        }}
      >
        {(this.props.comparePartyOptions || []).map(({ key, label, color }) => (
          <ToggleButton key={key} value={key}>
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                backgroundColor: color,
                mr: 0.5,
                flexShrink: 0,
              }}
            />
            {label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
    </>
)}
  </Paper>

)}

        </ReactMap>
      </div>
    );
  }
}

export default withRouter(MapComponent);
